<template>
  <div>
    <b-form-radio-group v-model="selectedStatus" buttons size="sm">
      <b-form-radio
        v-model="selectedStatus"
        v-b-tooltip.hover
        name="good"
        class="statusButtons goodButton"
        :value="0"
        :title="$t(goodStatusExplanation)"
        ><slot>{{ $t(localeConsts.goodStatus) }}</slot></b-form-radio
      >

      <b-form-radio
        v-model="selectedStatus"
        v-b-tooltip.hover
        name="improvable"
        class="statusButtons improvableButton"
        :value="1"
        :title="$t(improvableStatusExplanation)"
        ><slot>{{ $t(localeConsts.improvableStatus) }}</slot></b-form-radio
      >

      <b-form-radio
        v-model="selectedStatus"
        v-b-tooltip.hover
        name="bad"
        class="statusButtons badButton"
        :value="2"
        :title="$t(badStatusExplanation)"
        ><slot>{{ $t(localeConsts.badStatus) }}</slot></b-form-radio
      >
    </b-form-radio-group>
  </div>
</template>

<script>
export default {
  name: 'StatusReportStatusButtons',
  props: {
    goodStatusExplanation: {
      type: String,
      default: ''
    },

    improvableStatusExplanation: {
      type: String,
      default: ''
    },

    badStatusExplanation: {
      type: String,
      default: ''
    },

    selected: {
      type: [Number, String],
      default: null
    }
  },

  data() {
    return {
      localeConsts: {
        goodStatus: 'STATUSREPORTS.GOOD',
        improvableStatus: 'STATUSREPORTS.IMPROVABLE',
        badStatus: 'STATUSREPORTS.BAD'
      },

      selectedStatus: this.selected
    }
  },

  watch: {
    selectedStatus(newStatus) {
      this.$emit('selectedStatusEvent', newStatus)
    }
  }
}
</script>

<style lang="scss">
$good-color: #008000;
$improvable-color: #dec20b;
$bad-color: #ae0000;
$border-color: #8b69a9;

/*status buttons*/

.statusButtons {
  font-weight: bold;
  background-color: white !important;
}

.statusButtons:hover {
  background-color: #e8e8e8 !important;
}

.goodButton {
  color: $good-color !important;
  border: 1px solid $border-color;
  border-top-left-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
}

.improvableButton {
  color: $improvable-color !important;
  border: 1px solid $border-color;
}

.badButton {
  color: $bad-color !important;
  border: 1px solid $border-color;
  border-top-right-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}

/*radioButtons*/

input[type='radio'] {
  margin-right: 5px;
}
</style>
